import { useTranslation } from 'react-i18next';

const ErrorStep = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-5 py-10 text-center">
      <p className="text-xl font-bold text-text-primary">{t('plaid.modal.error.heading')}</p>
      <p className="text-sm leading-5 text-text-secondary">{t('plaid.modal.error.subtext')}</p>
    </div>
  );
};

export default ErrorStep;
